export const AcceptTermsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={13}
      height={13}
      x={1}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        stroke="#fff"
        strokeLinejoin="round"
        d="M7.5 13.333a5.815 5.815 0 0 0 4.125-1.708A5.814 5.814 0 0 0 13.333 7.5a5.815 5.815 0 0 0-1.708-4.125A5.815 5.815 0 0 0 7.5 1.667a5.816 5.816 0 0 0-4.125 1.708A5.816 5.816 0 0 0 1.667 7.5a5.816 5.816 0 0 0 1.708 4.125A5.815 5.815 0 0 0 7.5 13.333Z"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m5.167 7.5 1.75 1.75 3.5-3.5"
      />
    </mask>
    <g mask="url(#a)">
      <path fill="#fff" d="M.5.5h14v14H.5V.5Z" />
    </g>
  </svg>
);
